import React from 'react'
import { MRF_CONTACTS } from '../../constants/mrf-contacts'

export default function ContactDetails({ className }) {
  return (
    <div className={className} aria-label="Recapiti ufficiali MRF">
      {MRF_CONTACTS.map(contact => (
        <p key={contact.href}>
          <strong>{contact.label}: </strong>
          <a href={contact.href} style={contact.href.startsWith('tel:') ? { whiteSpace: 'nowrap' } : undefined}>{contact.value}</a>
        </p>
      ))}
    </div>
  )
}
